import { CandyOffIcon } from './CandyOffIcon';

/**
 * author: Michael Irigoyen
 * id 9C3124FB-E9F8-468A-9D51-2CAD3342BEE7
 * name candy-off
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/candy-off.svg
 * tags
 * - Food / Drink 
 */
export const ChocolateOffIcon = CandyOffIcon;
export default ChocolateOffIcon